import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useKeycloak } from '@react-keycloak/web'

import May from '../components/permissions/May'
import NoAccess from './NoAccess'
import { defaultRoutes, defaultMobileRoutes } from "../../constants/Permissions";

export function PrivateRoute({ component: Component, ...rest }) {
  const [keycloak] = useKeycloak()

  return (
    <Route
      {...rest}
      render={(props) =>
        keycloak.authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  )
}

export function PrivilegedRoute({ component: Component, permission, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <May 
          perform={permission}
          yes={() => ( <Component {...props} /> )}
          no={() => ( <NoAccess/> )}
        />
      )}
    />
  )
}

export function RedirectDefaultRoute ({ isMobileDevice=false }) {
  const { keycloak } = useKeycloak()
  const roles = (keycloak && keycloak.tokenParsed) ? keycloak.tokenParsed.realm_access.roles : [];
  let path = "/app/no-access";

  if (roles) {
    for ( var i = 0; i < roles.length; i++) {
      const maybePath  = isMobileDevice ? defaultMobileRoutes[roles[i]] : defaultRoutes[roles[i]];

      if (maybePath) {
        path = maybePath;
        break;
      }
    }
  }

  return <Redirect to={{pathname: path}}/>
}
